module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Section board-list"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile is-gapless search"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchBoard($event)
      }
    }
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_content),
      expression: "search_content"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "查找版面"
    },
    domProps: {
      "value": (_vm.search_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_content = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.boards), function(section, i) {
    return _c('section-card', {
      key: section.name,
      attrs: {
        "section": section
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "iconfont icon-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa4c8ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Section.vue
// module id = 250
// module chunks = 1